import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getDashboardData } from '@/data/dashboard';

/**
 * React Query hook for dashboard data
 * Implements aggressive caching per Engineering Playbook
 */
export function useDashboard() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['dashboard', user?.id],
    queryFn: () => getDashboardData(user!.id),
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,      // Fresh for 5 minutes
    gcTime: 30 * 60 * 1000,        // Keep in memory for 30 min
    refetchOnMount: false,          // Don't refetch if cached
    refetchOnWindowFocus: false,    // Don't refetch on tab focus
  });
}
